import SubtitleMenuItem from "./subtitle_menu_item";

export default class OffSubtitleItem extends SubtitleMenuItem {
  constructor({ player } = {}) {
    super({ player });
  }

  label() {
    return "Off"
  }

  handleClick() {
    const subtitleOffClickEvent = new Event('subtitleOffClick', { bubbles: true });
    this._el.dispatchEvent(subtitleOffClickEvent);
  }
}
